"use client";

import { cn } from "@workspace/ui";
import { Icons } from "@workspace/ui/components/icons";

import {
  applyCheckoutDistinctId,
  usePaymentHref,
} from "~/components/common/cta/button";
import { useAnalytics } from "~/lib/analytics";

export const VercelFeaturedBadge = ({ className }: { className?: string }) => {
  const { track } = useAnalytics();

  return (
    <a
      href="https://vercel.com/templates/authentication/next-js-saas-starter"
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "text-muted-foreground/80 hover:text-muted-foreground flex items-center font-medium",
        className,
      )}
      onClick={() => track("featured_badge_click", { id: "vercel" })}
    >
      <Icons.LaurelLeft className="-mr-2 size-10 stroke-1 md:-mr-3 md:size-13" />
      <div className="flex flex-col items-center justify-center gap-0.5">
        <span className="text-sm leading-none md:text-lg">
          Top SaaS starter kit
        </span>
        <span className="inline-flex items-center text-xs md:text-sm">
          by{" "}
          <Icons.Vercel className="ml-1 inline-block size-2.5 md:mr-0.5 md:ml-1.5 md:size-3" />{" "}
          Vercel
        </span>
      </div>
      <Icons.LaurelRight className="-ml-2 size-10 stroke-1 md:-ml-3 md:size-13" />
    </a>
  );
};

export const AIFeaturedBadge = ({ className }: { className?: string }) => {
  const href = usePaymentHref();
  const { track } = useAnalytics();

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "text-muted-foreground/80 hover:text-muted-foreground flex cursor-pointer items-center font-medium",
        className,
      )}
      onClick={(e) => {
        applyCheckoutDistinctId(e.currentTarget);
        track("featured_badge_click", { id: "ai" });
      }}
    >
      <Icons.LaurelLeft className="-mr-2 size-10 stroke-1 md:-mr-3 md:size-13" />
      <div className="flex flex-col items-center justify-center gap-0.5">
        <span className="text-sm leading-none md:text-lg">
          Best AI boilerplate
        </span>
        <span className="inline-flex items-center text-xs md:text-sm">
          by{" "}
          {[Icons.Cursor, Icons.Claude, Icons.OpenAI].map((Icon, index) => (
            <Icon
              key={index}
              className={cn(
                "mt-px ml-0.5 inline-block size-3.5 first:ml-1 md:ml-1 md:size-4.5 md:first:ml-1.5",
                index === 2 && "size-3 md:size-4",
              )}
            />
          ))}
        </span>
      </div>
      <Icons.LaurelRight className="-ml-2 size-10 stroke-1 md:-ml-3 md:size-13" />
    </a>
  );
};
